var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _vm.loadingSpinner
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-center" },
          [
            _c("b-spinner", {
              staticStyle: { width: "3rem", height: "3rem" },
              attrs: { variant: "success", label: "Spinning" },
            }),
          ],
          1
        )
      : _vm._e(),
    !_vm.loadingSpinner
      ? _c(
          "div",
          [
            _c(
              "b-card",
              { staticClass: "my-2" },
              [
                _c(
                  "b-row",
                  [
                    _c("b-col", [
                      _c("h2", { staticClass: "text-primary m-0 p-0" }, [
                        _vm._v("Product manufactured inhouse?"),
                      ]),
                    ]),
                    _c(
                      "b-col",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-start my-1",
                        attrs: { cols: "12" },
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "mr-2 text-primary",
                            attrs: { for: "check-button" },
                          },
                          [_vm._v("No")]
                        ),
                        _c("b-form-checkbox", {
                          attrs: {
                            checked: "true",
                            name: "check-button",
                            switch: "",
                            inline: "",
                          },
                          model: {
                            value: _vm.product.inHouseManufactured,
                            callback: function ($$v) {
                              _vm.$set(_vm.product, "inHouseManufactured", $$v)
                            },
                            expression: "product.inHouseManufactured",
                          },
                        }),
                        _c(
                          "label",
                          {
                            staticClass: "text-primary",
                            attrs: { for: "check-button" },
                          },
                          [_vm._v("Yes")]
                        ),
                      ],
                      1
                    ),
                    _c("b-col", [_c("h3")]),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-center" },
                      [
                        _vm.loading
                          ? _c("b-spinner", {
                              staticClass: "mx-2",
                              attrs: { large: "" },
                            })
                          : _vm._e(),
                        _vm.loading
                          ? _c("span", [_vm._v("Loading...")])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.product.inHouseManufactured == true
              ? _c(
                  "form-wizard",
                  {
                    ref: "formWiz",
                    staticClass: "mb-3",
                    attrs: {
                      color: "#B1D06C",
                      title: null,
                      subtitle: null,
                      shape: "square",
                      "finish-button-text": "Submit",
                      "back-button-text": "Previous",
                    },
                    on: { "on-complete": _vm.formSubmitted },
                  },
                  [
                    _c(
                      "tab-content",
                      {
                        attrs: {
                          title: "Details",
                          "before-change": _vm.validateProduct,
                        },
                      },
                      [
                        _c("AddProductBuy", {
                          ref: "productDetails",
                          on: { onchange: _vm.detailsChanged },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "tab-content",
                      {
                        attrs: {
                          title: "Bill Of Materials",
                          "before-change": _vm.validateUOM,
                        },
                      },
                      [
                        _c("AddBOM", {
                          ref: "bomDetails",
                          on: { onchange: _vm.bomChanged },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "tab-content",
                      {
                        attrs: {
                          title: "Pricing",
                          "before-change": _vm.validatePricing,
                        },
                      },
                      [
                        _c("ConfirmProduct", {
                          ref: "pricingDetails",
                          attrs: { Product: _vm.product },
                          on: { onchange: _vm.pricingChanged },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "tab-content",
                      { attrs: { title: "Finish" } },
                      [
                        _c(
                          "b-container",
                          {
                            staticClass:
                              "d-flex justify-content-center last_step flex-column",
                          },
                          [
                            _c("img", {
                              staticStyle: { height: "200px" },
                              attrs: {
                                src: require("./check-mark.svg"),
                                alt: "",
                              },
                            }),
                            _c(
                              "h2",
                              { staticClass: "text-center mt-3 text-primary" },
                              [_vm._v("Submit and Confirm")]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.product.inHouseManufactured == false
              ? _c(
                  "form-wizard",
                  {
                    ref: "formWiz",
                    staticClass: "mb-3",
                    attrs: {
                      color: "#B1D06C",
                      title: null,
                      subtitle: null,
                      shape: "square",
                      "finish-button-text": "Submit",
                      "back-button-text": "Previous",
                    },
                    on: { "on-complete": _vm.formSubmitted },
                  },
                  [
                    _c(
                      "tab-content",
                      {
                        attrs: {
                          title: "Details",
                          "before-change": _vm.validateProduct,
                        },
                      },
                      [
                        _c("AddProduct", {
                          ref: "productDetails",
                          on: { onchange: _vm.detailsChanged },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "tab-content",
                      {
                        attrs: {
                          title: "Pricing",
                          "before-change": _vm.validatePricing,
                        },
                      },
                      [
                        _c("ConfirmProduct", {
                          ref: "pricingDetails",
                          attrs: { Product: _vm.product },
                          on: { onchange: _vm.pricingChanged },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "tab-content",
                      { attrs: { title: "Finish" } },
                      [
                        _c(
                          "b-container",
                          {
                            staticClass:
                              "d-flex justify-content-center last_step flex-column",
                          },
                          [
                            _c("img", {
                              staticStyle: { height: "200px" },
                              attrs: {
                                src: require("./check-mark.svg"),
                                alt: "",
                              },
                            }),
                            _c(
                              "h2",
                              { staticClass: "text-center mt-3 text-primary" },
                              [_vm._v("Submit and Confirm")]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }